import { StaffSectionData, StatusVerification } from "../../../api";

/**
 * Section verification service - manages section approval/denial logic
 * Pure functions that work with section data
 */
export class SectionVerificationService {
    /**
     * Mark a section as confirmed/accepted
     */
    static confirmSection(sections: StaffSectionData[], sectionGU: string): StaffSectionData[] {
        return sections.map(section =>
            section.sectionGU === sectionGU
                ? { ...section, status: StatusVerification.Accepted }
                : section
        );
    }

    /**
     * Check if all sections have been reviewed
     */
    static allSectionsReviewed(sections: StaffSectionData[]): boolean {
        if (sections.length === 0) return false;
        return sections.every(section => section.status !== StatusVerification.None);
    }

    /**
     * Restore saved section verification states (from a Pending draft) into the section list
     */
    static restoreSectionVerifications(
        sections: StaffSectionData[],
        saved: { sectionGU: string | null | undefined; status: StatusVerification }[]
    ): StaffSectionData[] {
        return sections.map(section => {
            const savedSection = saved.find(s => s.sectionGU === section.sectionGU);
            return savedSection ? { ...section, status: savedSection.status } : section;
        });
    }

    /**
     * Prepare section verification data for API submission
     */
    static prepareSectionVerifications(sections: StaffSectionData[]) {
        return sections.map(section => ({
            sectionGU: section.sectionGU ?? '',
            status: section.status,
            denyReason: section.denyReason ?? ''
        }));
    }
}
